export enum GoodPracticeStatusOngoing {
  PENDING = 'PENDING', // Status Pending
  EVT1 = 'EVT1', // Request for translation (EN)
  EVL = 'EVL', // Under evaluation
  EVLDY = 'EVLDY', // Evaluated - Approved
  E00 = 'E00', // Evaluation - Refused
  EVLM = 'EVLM', // More info required
  EVT2 = 'EVT2', // Request for translation (DE/FR/EN)
}
